module.exports = __webpack_public_path__ + "static/media/outlook.eaee678b.png";